var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMenuWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-out-mono"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.175 9.00899C17.175 8.55336 16.8057 8.18399 16.35 8.18399H7.5533C7.09766 8.18399 6.7283 8.55336 6.7283 9.00899C6.7283 9.46463 7.09766 9.83399 7.5533 9.83399H16.35C16.8057 9.83399 17.175 9.46463 17.175 9.00899Z",
    fill: "#8B95A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8418 4.50176C11.5197 4.824 11.5198 5.34636 11.842 5.66848L15.1832 9.00837L11.8419 12.3496C11.5198 12.6718 11.5198 13.1942 11.8419 13.5164C12.1641 13.8386 12.6865 13.8386 13.0087 13.5164L16.9334 9.59162C17.0881 9.43689 17.1751 9.22701 17.175 9.00818C17.175 8.78935 17.0881 8.57949 16.9333 8.42479L13.0086 4.50154C12.6863 4.17941 12.1639 4.17951 11.8418 4.50176Z",
    fill: "#8B95A1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.32239 3.53998C7.58097 3.53998 7.82897 3.64271 8.01182 3.82556C8.19466 4.0084 8.29739 4.2564 8.29739 4.51498V5.78548C8.29739 6.24112 8.66675 6.61048 9.12239 6.61048C9.57802 6.61048 9.94739 6.24112 9.94739 5.78548V4.51498C9.94739 3.81879 9.67083 3.15111 9.17854 2.65883C8.68626 2.16655 8.01858 1.88998 7.32239 1.88998H3.98639C3.29019 1.88998 2.62251 2.16655 2.13023 2.65883C1.63795 3.15111 1.36139 3.81879 1.36139 4.51498V13.5037C1.36168 14.1997 1.63837 14.8675 2.13062 15.3595C2.62287 15.8516 3.29038 16.128 3.98639 16.128H7.32239C8.01858 16.128 8.68626 15.8514 9.17854 15.3591C9.67083 14.8669 9.94739 14.1992 9.94739 13.503V12.2355C9.94739 11.7798 9.57802 11.4105 9.12239 11.4105C8.66675 11.4105 8.29739 11.7798 8.29739 12.2355V13.503C8.29739 13.7616 8.19466 14.0096 8.01182 14.1924C7.82897 14.3753 7.58097 14.478 7.32239 14.478H3.98639C3.72787 14.478 3.47994 14.3753 3.2971 14.1926C3.11427 14.0098 3.0115 13.7619 3.01139 13.5034V4.51498C3.01139 4.2564 3.11411 4.0084 3.29696 3.82556C3.4798 3.64271 3.7278 3.53998 3.98639 3.53998H7.32239Z",
    fill: "#8B95A1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenuWithdraw);
export default __webpack_public_path__ + "static/media/icon_menu_withdraw.f70f73f3aa34e4014f8ba72243a5315c.svg";
export { ForwardRef as ReactComponent };